export default __webpack_public_path__ + "static/banner1-2e6e9a747200ffd8814bb642493bb255.png";